import { ModalComponent } from './modal';
import { modalsMap } from './modals-map';

export const Modals = () => {
  return <ModalComponent components={modalsMap} />;
};
